var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-confirm-dialog" },
    [
      _c(
        "x-dialog",
        {
          staticClass: "app-confirm-dialog-position app-pr",
          attrs: { show: _vm.show }
        },
        [
          _c("div", [
            _c("div", { staticClass: "text" }, [
              _vm._v("\n        " + _vm._s(_vm.tips) + "\n      ")
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "btn", on: { click: _vm.close } }, [
            _vm._v("\n      确定\n    ")
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b28bba94", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b28bba94","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/simple/appTipsDialog/App-tips-dialog.vue
// module id = null
// module chunks = 